import {
  Button,
  Col,
  Modal,
  Popconfirm,
  Row,
  Typography,
  Card,
  Tag,
} from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  GAME_WALLET_TO_MAIN_WALLET,
  USER_DELETE,
  USER_UNLOCK,
} from "../../../lib/config";
import { DeleteDataOnServer, UpdateSingleDataOnServer } from "../../../lib/api";
import toast from "react-hot-toast";
import PasswordReset from "./password_reset";
import moment from "moment-timezone";
import { moneyFormat } from "../../../lib/global_functions";

const { Text } = Typography;
export default function UserDetailPage({ detail, closeDrawer }) {
  const { permissions, access_token, csrf_token, ui_size, playing_user_ids } = useSelector(
    (state) => state.user
  );

  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  async function unlockUser(user_id) {
    setLoading(true);
    await UpdateSingleDataOnServer(
      USER_UNLOCK,
      user_id,
      access_token,
      csrf_token
    )
      .then(() => {
        closeDrawer(true);
        toast.success("User Unlock Done");
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response?.data?.error || "Connection Error");
      });
  }

  async function deleteHandler(id) {
    setLoading(true);

    await DeleteDataOnServer(USER_DELETE, id, access_token, csrf_token)
      .then(() => {
        setLoading(false);
        toast.success("User delete successfully");
        closeDrawer(true);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Delete failed");
      });
  }

  async function updateWalletHandler(id) {
    setLoading(true);
    await UpdateSingleDataOnServer(
      GAME_WALLET_TO_MAIN_WALLET,
      id,
      access_token,
      csrf_token
    )
      .then(() => {
        setLoading(false);
        toast.success("Updated game wallet to main wallet successfully");
        closeDrawer(true);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Update Failed");
      });
  }

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={10}>
          <Row gutter={[8, 16]}>
            <Col span={7}>
              <Text>Nick Name</Text>
            </Col>
            <Col span={17}>
              <Text>{detail.nick_name}</Text>
            </Col>

            <Col span={7}>
              <Text>Code</Text>
            </Col>
            <Col span={17}>
              <Text>{detail.code}</Text>
            </Col>

            <Col span={7}>
              <Text>Agent Code</Text>
            </Col>
            <Col span={17}>
              <Text>{detail.agent_code}</Text>
            </Col>

            <Col span={7}>
              <Text>Deep Link Code</Text>
            </Col>
            <Col span={17}>
              <Text>{detail.deep_link_code || "-"}</Text>
            </Col>

            <Col span={7}>
              <Text>Date Of Birth</Text>
            </Col>
            <Col span={17}>
              <Text>
                {detail.dob
                  ? moment
                      .utc(detail.dob)
                      .tz("Asia/Yangon")
                      .format("DD-MM-YYYY")
                  : "N/A"}
              </Text>
            </Col>

            <Col span={7}>
              <Text>Language</Text>
            </Col>
            <Col span={17}>
              <Text>{detail.language}</Text>
            </Col>

            <Col span={24} style={{ display: "flex", alignItems: "center" }}>
              <Col span={7}>
                <Text>Avatar Icon</Text>
              </Col>
              <Col span={17}>
                <img
                  alt="Avatar Img"
                  src={detail.avatar_url}
                  style={{
                    width: 50,
                    height: 50,
                    borderRadius: "50%",
                  }}
                />
              </Col>
            </Col>

            <Col span={7}>
              <Text>Is Active?</Text>
            </Col>
            <Col span={17}>
              <Tag color={detail.is_active ? "lime" : "red"}>
                <Text style={{ color: detail.is_active ? "lime" : "red" }}>
                  {detail.is_active ? "Yes" : "No"}
                </Text>
              </Tag>
            </Col>

            <Col span={7}>
              <Text>Is Locked?</Text>
            </Col>
            <Col span={17}>
              <Tag color={detail.is_locked ? "lime" : "red"}>
                <Text style={{ color: detail.is_locked ? "lime" : "red" }}>
                  {detail.is_locked ? "Yes" : "No"}
                </Text>
              </Tag>
            </Col>
          </Row>
          <Col span={24} style={{ marginTop: "30px" }}>
            <Row gutter={12}>
              {permissions.includes("AGENT_UPDATE_USER") && (
                <Col>
                  <Popconfirm
                    title="Are You Sure Unlock This User?"
                    okText="Yes"
                    cancelText="No"
                    onConfirm={() => unlockUser(detail.id)}
                  >
                    <Button
                      size={ui_size}
                      loading={loading}
                      type="dashed"
                      disabled={!detail.is_locked}
                    >
                      Unlock
                    </Button>
                  </Popconfirm>
                </Col>
              )}
              {permissions.includes("AGENT_UPDATE_USER") && (
                <Col>
                  <Button
                    size={ui_size}
                    onClick={() => setShowModal(true)}
                    type="primary"
                  >
                    Password Reset
                  </Button>
                </Col>
              )}

              {permissions.includes("AGENT_DELETE_USER") && (
                <Col>
                  <Popconfirm
                    title="Are You Sure Delete This User?"
                    okText="Yes"
                    cancelText="No"
                    onConfirm={() => deleteHandler(detail.id)}
                  >
                    <Button
                      size={ui_size}
                      loading={loading}
                      type="primary"
                      danger
                    >
                      Delete
                    </Button>
                  </Popconfirm>
                </Col>
              )}
            </Row>
          </Col>
        </Col>

        <Col span={12}>
          <Card title="Wallet Details" size={ui_size}>
            <Row gutter={[8, 16]}>
              <Col span={12}>
                <Text strong>Currency:</Text>
              </Col>
              <Col span={12}>
                <Text>{detail?.wallet?.currency || "-"}</Text>
              </Col>

              <Col span={12}>
                <Text strong>Exchange Rate:</Text>
              </Col>
              <Col span={12}>
                <Text>{moneyFormat(detail?.wallet?.exchange_rate || 0)}</Text>
              </Col>

              <Col span={12}>
                <Text strong>Game Points:</Text>
              </Col>
              <Col span={12}>
                <Text>{moneyFormat(detail?.wallet?.game_points || 0)}</Text>
              </Col>

              <Col span={12}>
                <Text strong>Points:</Text>
              </Col>
              <Col span={12}>
                <Text>{moneyFormat(detail?.wallet?.points || 0)}</Text>
              </Col>

              <Col span={12}>
                <Text strong>Promo Points:</Text>
              </Col>
              <Col span={12}>
                <Text>{moneyFormat(detail?.wallet?.promo_points || 0)}</Text>
              </Col>

              <Col span={12}>
                <Text strong>Total Deposit:</Text>
              </Col>
              <Col span={12}>
                <Text>{moneyFormat(detail?.wallet?.total_deposit || 0)}</Text>
              </Col>

              <Col span={12}>
                <Text strong>Total Withdraw:</Text>
              </Col>
              <Col span={12}>
                <Text>{moneyFormat(detail?.wallet?.total_withdraw || 0)}</Text>
              </Col>

              <Col span={12}>
                <Text strong>Transfer Ratio:</Text>
              </Col>
              <Col span={12}>
                <Text>{detail?.wallet?.transfer_ratio || "-"}</Text>
              </Col>

              <Col span={12}>
                <Text strong>Withdraw Band Points:</Text>
              </Col>
              <Col span={12}>
                <Text>
                  {moneyFormat(detail?.wallet?.withdraw_band_points || 0)}
                </Text>
              </Col>

              <Col span={12}>
                <Text strong>Withdraw Request Points:</Text>
              </Col>
              <Col span={12}>
                <Text>
                  {moneyFormat(detail?.wallet?.withdraw_request_points || 0)}
                </Text>
              </Col>

              <Col span={12}>
                <Text strong>Created At:</Text>
              </Col>
              <Col span={12}>
                <Text>
                  {detail.created_at
                    ? moment
                        .utc(detail.created_at)
                        .tz("Asia/Yangon")
                        .format("DD-MM-YYYY HH:mm:ss")
                    : "N/A"}
                </Text>
              </Col>

              <Col span={12}>
                <Text strong>Updated At:</Text>
              </Col>
              <Col span={12}>
                <Text>
                  {detail.updated_at
                    ? moment
                        .utc(detail.updated_at)
                        .tz("Asia/Yangon")
                        .format("DD-MM-YYYY HH:mm:ss")
                    : "N/A"}
                </Text>
              </Col>
            </Row>
          </Card>

          {
            permissions.includes("AGENT_CREATE_USER_TRANSACTION") && (
              <Popconfirm
                title="Are you sure to change game wallet to main wallet?"
                okText="Yes"
                cancelText="No"
                onConfirm={() => updateWalletHandler(detail.id)}
              >
                <Button
                  size={ui_size}
                  type="primary"
                  style={{ marginTop: "10px" }}
                  disabled={playing_user_ids.includes(detail.id) || detail.play_game}
                >
                  Game To Main Wallet
                </Button>
              </Popconfirm>
            )}
        </Col>
      </Row>
      <Modal
        footer={null}
        title="Password Reset Form"
        open={showModal}
        onCancel={() => setShowModal(false)}
        destroyOnClose
      >
        <PasswordReset detail={detail} closeDrawer={closeDrawer} />
      </Modal>
    </>
  );
}
